import { UserRolesEnum } from '../enums/user-roles.enum';
import { get } from '../services/storage';

export const isBackOfficeUser = (): boolean => {
  const userRole = get('role');

  return userRole !== UserRolesEnum.estateAdmin && userRole !== UserRolesEnum.estateUser;
};
